import { createFileRoute } from '@tanstack/react-router';

import { EmailLogPage } from '@/pages/emails/email-log-page';

export const Route = createFileRoute('/emails')({
  component: EmailLogPage,
});
